import { useEffect } from 'react';
import { clarity } from 'react-microsoft-clarity';
import { ANALYTICS_CONFIG } from '../../../config/analyticsConfig';

const ClarityInit = () => {
  useEffect(() => {
    // TODO : make clarity variable //
    if (process.env.REACT_APP_PHYLLO_ENV === 'production') {
      clarity.init(ANALYTICS_CONFIG.clarityTrackingId);
    }
  }, []);

  return null;
};

export default ClarityInit;
